import BackButton from './BackButton';
import Breadcrumbs from './Breadcrumbs';
import './Navigation.css';

/**
 * Standardized page header component with optional back button, breadcrumbs, and actions.
 *
 * Layout:
 * [Breadcrumbs (if provided)]
 * [Back Button] [Title + Subtitle] [Action Buttons]
 *
 * @param {Object} props
 * @param {string} [props.backTo] - Back button destination path
 * @param {string} [props.backLabel] - Back button text
 * @param {Object} [props.backState] - State to pass on back navigation
 * @param {string} props.title - Page title
 * @param {string} [props.subtitle] - Page subtitle
 * @param {React.ReactNode} [props.actions] - Right-side action buttons
 * @param {Array} [props.breadcrumbs] - Breadcrumb items [{label, to}]
 * @param {string} [props.className] - Additional CSS classes for header
 */
function PageHeader({
  backTo,
  backLabel,
  backState,
  title,
  subtitle,
  actions,
  breadcrumbs,
  className = ''
}) {
  return (
    <header className={`nav-header ${className}`.trim()}>
      <div className="nav-header-content">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumbs items={breadcrumbs} />
        )}
        <div className="nav-header-row">
          <div className="nav-header-left">
            {backTo && backLabel && (
              <BackButton
                to={backTo}
                label={backLabel}
                state={backState}
              />
            )}
            <div className="nav-header-titles">
              <h1 className="nav-title">{title}</h1>
              {subtitle && <p className="nav-subtitle">{subtitle}</p>}
            </div>
          </div>
          {actions && (
            <div className="nav-header-actions">
              {actions}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default PageHeader;
